import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue'

    // Inject the CTA text from the parent component
    
export default /*#__PURE__*/_defineComponent({
  __name: 'AckTermsCta',
  setup(__props) {

    const ctaText = inject('ctaText', '')

    if (!ctaText) {
        throw new Error('AckTermsCta must be used within an AckTermsButton')
    }

return { __sfc: true,ctaText }
}

})